<div class="user-info-panel" [class.white-background]="!isEditing" [class.grey-background]="isEditing">
  <div class="card">
    @if (isLoading) {
      <div class="loading-container">
        <p class="loading-text">Loading provider information...</p>
      </div>
    } @else if (detailsExpanded) {
      <div class="provider-card">
        @if (enableEdit) {
          <div class="grid">
            <div [class.grid-col-8]="!isTransportationType" [class.grid-col-4]="isTransportationType">
              @if (userType === adminUserTypes.Provider) {
                <div class="provider-header-grid">
                  <h2 data-pw="business_name_title" data-qa="business_name_title">{{ providerData!.businessName }}</h2>
                </div>
                @if (showReviewStatus || isTransportationType) {
                  <span class="sub-header navy-text" data-pw="provider_type_label" data-qa="provider_type_label">{{
                    providerTypeLabel
                  }}</span>
                }
              } @else if (userType === adminUserTypes.Schools) {
                <h2 data-pw="school_name_title" data-qa="school_name_title">
                  {{ schoolData!.schoolName }}
                  @if (schoolData!.institutionSchoolCount > 1) {
                    (<a
                      class="institution-link"
                      tabindex="0"
                      (click)="onInstitutionClick()"
                      (keyup.enter)="onInstitutionClick()"
                      >{{ schoolData!.institutionName }}</a
                    >)
                  }
                </h2>
                @if (schoolData!.schoolStatus) {
                  <span class="sub-header navy-text" data-pw="school_status_label" data-qa="school_status_label">{{
                    schoolData!.schoolStatus
                  }}</span>
                }
              } @else if (userType === adminUserTypes.Households) {
                <div class="household-header-grid">
                  <h2 data-pw="household_name_title" data-qa="household_name_title">
                    {{ getFullName() }}
                  </h2>
                  <h2 class="pid-number" data-pw="pid_number" data-qa="pid_number">
                    Program ID: {{ householdData!.pidNumber }}
                  </h2>
                </div>
              }
            </div>
            @if (isTransportationType) {
              <div class="grid-col-4">
                <h2 class="pid-number" data-pw="pid_number" data-qa="pid_number">
                  Program ID : {{ providerData!.recordNumber || '-' }}
                </h2>
              </div>
            }
            <div class="review-edit grid-col-4">
              <div class="review">
                @if (userType === adminUserTypes.Provider && showReviewStatus) {
                  <status-badge
                    class="status"
                    [status]="enrollmentStatus ?? undefined"
                    [message]="enrollmentStatus ?? undefined"></status-badge>
                  @if (providerData!.enrollmentStatus && providerData!.enrollmentStatus === 'Verified') {
                    <status-badge
                      [status]="verifiedStatus"
                      [message]="'Verified'"
                      [icon]="blueCheckIcon"
                      [svgHeight]="17"
                      [svgWidth]="16"
                      [verified]="true"></status-badge>
                  }
                } @else if (userType === adminUserTypes.Schools && schoolRestrictionMessage) {
                  <status-badge class="school-status" [status]="schoolStatus" [message]="schoolRestrictionMessage">
                  </status-badge>
                }
              </div>
              @if (!isEditing && canEdit) {
                <button
                  aria-label="Edit User Info"
                  class="edit-user-action status-badge"
                  data-qa="edit-user-info-button"
                  disableRipple
                  mat-icon-button
                  (click)="onEditClick()">
                  <mat-icon class="mat-action-icon" svgIcon="k12-edit"></mat-icon>
                  <span class="edit-text">Edit</span>
                </button>
              }
            </div>
          </div>
        }

        @if (!isEditing) {
          <div
            class="user-card"
            [style.padding]="
              isEditing && (userType === adminUserTypes.Schools || userType === adminUserTypes.Households)
                ? '0'
                : '1.5rem'
            ">
            @if (userType === adminUserTypes.Schools) {
              <lib-school-info [schoolData]="schoolData"></lib-school-info>
            } @else if (userType === adminUserTypes.Households) {
              <lib-household-info
                [householdData]="householdData"
                [states]="states"
                [showIncomeVerification]="currentUserType !== adminUserTypes.Households">
              </lib-household-info>
            } @else {
              <lib-provider-info
                [providerData]="providerData"
                [ownerDetails]="ownerDetails"
                [states]="states"
                [showReviewStatus]="userType === adminUserTypes.Provider && !showReviewStatus">
              </lib-provider-info>
            }
          </div>
        }

        @if (isEditing) {
          @if (userType === adminUserTypes.Provider) {
            <form [formGroup]="providerForm">
              @if (!showReviewStatus) {
                <!-- Basic Information Component (provider portal only) -->
                <lib-basic-information [formGroup]="providerForm" [providerData]="providerData">
                </lib-basic-information>
              } @else {
                <!-- Personal Information Component -->
                <lib-personal-information
                  [formGroup]="providerForm"
                  [providerData]="providerData"
                  [providerType]="providerType ?? providerData!.type!"
                  [showReviewStatus]="showReviewStatus">
                </lib-personal-information>

                <!-- Provider Details Component -->
                <lib-provider-details
                  [formGroup]="providerForm"
                  [providerData]="providerData"
                  [showReviewStatus]="showReviewStatus"
                  (enrollmentStatuses)="providerEnrollmentStatuses = $event"
                  [subServices]="subServices"
                  [getTherapyEmployeeLength]="getTherapyEmployeeLength.bind(this)"
                  [getTutoringEmployeeLength]="getTutoringEmployeeLength.bind(this)">
                </lib-provider-details>
              }

              <!-- Business Address Component -->
              <lib-business-address [formGroup]="providerForm" [states]="states" [showReviewStatus]="showReviewStatus">
              </lib-business-address>

              @if (isTherapyType || isTransportationType) {
                <!-- Personal Address Component -->
                <lib-personal-address
                  [formGroup]="providerForm"
                  [states]="states"
                  [showReviewStatus]="showReviewStatus">
                </lib-personal-address>
              }

              @if (isTutorType) {
                <!-- Tutor Personal Address Component for Tutor -->
                <lib-tutor-personal-address
                  [formGroup]="providerForm"
                  [employeeDetailService]="employeeDetailService"
                  [states]="states"
                  [showReviewStatus]="showReviewStatus">
                </lib-tutor-personal-address>
              }

              @if (isTherapyType || isTransportationType || (isTutorType && !showReviewStatus)) {
                <lib-license-info
                  [formGroup]="providerForm"
                  [providerType]="providerType ?? providerData!.type!"
                  [states]="states"
                  [subServices]="subServices"
                  [showReviewStatus]="showReviewStatus"
                  [userId]="providerData.id ?? ''">
                </lib-license-info>
              }
            </form>
          } @else if (userType === adminUserTypes.Schools) {
            <form [formGroup]="schoolForm">
              <!-- HDMA Information Component -->
              <lib-hdma-information [formGroup]="schoolForm" [schoolData]="schoolData"> </lib-hdma-information>

              <!-- School Details Component -->
              <lib-school-details
                [formGroup]="schoolForm"
                [schoolData]="schoolData"
                [aidProgramOptions]="aidProgramOptions"
                [institutionSchoolCount]="schoolData.institutionSchoolCount || 0">
              </lib-school-details>

              <!-- School Address Component -->
              <lib-school-address [formGroup]="schoolForm" [states]="states"> </lib-school-address>
            </form>
          } @else if (userType === adminUserTypes.Households) {
            <form [formGroup]="householdForm">
              <!-- Household Parent Information Component -->
              <lib-household-parent-info [formGroup]="householdForm" [householdData]="householdData">
              </lib-household-parent-info>

              <!-- Household Contact Information Component -->
              <lib-household-contact-info [formGroup]="householdForm" [states]="states"> </lib-household-contact-info>

              <!-- Household Financial Information Component -->
              <lib-household-financial-info [formGroup]="householdForm" [householdData]="householdData">
              </lib-household-financial-info>
            </form>
          }
        }
      </div>
    }
  </div>
</div>

@if (isEditing) {
  <div class="grid button-container">
    <div class="buttons grid-col-12">
      <button mat-flat-button class="cancel-button" (click)="onCancelClick()">Cancel</button>
      @if (userType === adminUserTypes.Provider) {
        <button class="save-button-small" mat-flat-button (click)="onProviderSaveClick()">Save Changes</button>
      } @else if (userType === adminUserTypes.Schools) {
        <button class="save-button-small" mat-flat-button (click)="onSchoolSaveClick()" [disabled]="schoolForm.invalid">
          Save Changes
        </button>
      } @else if (userType === adminUserTypes.Households) {
        <button
          class="save-button-small"
          mat-flat-button
          (click)="onHouseholdSaveClick()"
          [disabled]="householdForm.invalid">
          Save Changes
        </button>
      }
    </div>
    @if (isActiveFormInvalid()) {
      <div class="save-validation-summary grid-col-12" role="alert" aria-live="polite">
        <p class="save-validation-summary__title">Fix the following before saving:</p>
        <ul class="save-validation-summary__list">
          @for (item of getValidationSummary(); track item.path + item.message) {
            <li>
              <span class="save-validation-summary__field">{{ item.path }}</span
              ><span class="save-validation-summary__sep">: </span>{{ item.message }}
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
